import { render, staticRenderFns } from "./BatchForm.vue?vue&type=template&id=5c7da820"
import script from "./BatchForm.vue?vue&type=script&lang=js"
export * from "./BatchForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports